import React from 'react';
import PropTypes from 'prop-types';

const ErrorField = ({ children }) => {
    return <small className="t-error">{children}</small>;
};

ErrorField.propTypes = {
    children: PropTypes.node
};

export default ErrorField;
